import React, { useEffect, useRef, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { MapUtilitiesTypes } from '../MapUtilitiesMenu/enums';
import MapSettingPreference from './components/mapSettingPreference';
import { useIntl } from 'react-intl';
import './style.scss';

import { selectModuleMapSettings } from "Redux/actions";

const MapSetting = ({ mapRef }) => {
    const dispatch = useDispatch();
    const { messages, locale } = useIntl();
    const prevLocaleRef = useRef(localStorage.getItem('lan'));

    const handleSection = useCallback(() => {
        dispatch(selectModuleMapSettings(MapUtilitiesTypes.Default));
    }, [dispatch]);

    useEffect(() => {
        if (prevLocaleRef.current !== locale) {
            dispatch(selectModuleMapSettings(MapUtilitiesTypes.Default));
            prevLocaleRef.current = locale;
        }
    }, [locale, dispatch]);

    return (
        <div className="map-setting-wrapper">
            <h2 className="map-setting-header">{messages['permissions_mapsSetting']}</h2>
            <div className="map-setting-back">
                <label className="menuItem" onClick={handleSection}>
                    {messages['maputilities_back']}
                </label>
            </div>
            <MapSettingPreference mapRef={mapRef} />
        </div>
    );
};

export default MapSetting;